import { HttpInterceptorFn } from '@angular/common/http';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
	// TODO: implement this interceptor. It should handle the http errors.
	return next(req);
	// return next(req).pipe(
	// 	catchError(err => {
	// 		if (err.status === 401 && !req.url.includes('refresh_token') && !req.url.includes('verify_token')) {
	// 			const authService: AuthenticationService = inject(AuthenticationService);
	// 			authService.logout();
	// 		}
	// 		return throwError(() => err);
	// 	})
	// );
};
